<template>
  <div>
    <div v-if="debug_show_page_name==true" style="color:green;">page_0030_bulk_import</div>
    <app-header>esma</app-header>
    <div :class="'container ' + pageContainerSize">
      <title-and-slot title="旧データ取込"></title-and-slot>

      <dropdown
        :disabled="checkUserPermission(true,permissionMode.EXPORT) == false"
        :text="dropdown_label" type="warning btn  btn-xs btn-warning dropdown_yellow_import" style="margin-top:20px; " class=" "  >
        <li  style=";width:300px;margin-top:2px;">
          <a 
          :disabled="checkUserPermission(true,permissionMode.EXPORT) == false"
          class="btn btn-warning" style="width:300px;background:rgb(247, 218, 178);color:black;" 
          href='/api/temp_old_device_embedded_information/export_data/'
          target="temp_old_device_embedded_information"
        >{{btn_dev_label}}</a>
        </li>
        <li  style=";width:300px;margin-top:2px;">
          <a
          :disabled="checkUserPermission(true,permissionMode.EXPORT) == false"
          class="btn btn-warning" style="width:300px;background:rgb(247, 218, 178);color:black;" 
          href='/api/temp_old_certificate_information/export_data/'
          target="temp_old_certificate_information"
          >{{btn_cer_label}}</a>
        </li>
      </dropdown>
      <div>
        <input
          style="display: none;"
          @change="fileSelected"
          @click="fileClicked"
          type="file"
          name="csv_file"
          id="csv_file"
          data-cy="csv_file"
          ref="csv_file"
          accept="*/*"
        />
        <button
          :disabled="checkUserPermission(true,permissionMode.ADD) == false"
          type="button"
          class="btn btn-primary"
          style="min-width:100px;width:300px;margin-top:5px;"
          v-if="showChoseFile"
          @click="choseFile"
        >ファイルを選択（Excel）</button>
        <div v-if="uploading == true">
          <span
            style="font-size: 30px; color: #5b9bd5;"
            class="glyphicon glyphicon-refresh glyphicon-spin"
          ></span>
          アップロード中...
        </div>

        <div v-if="showUploadFile">
          <label
            v-if="this.selected_file_name != null && showUploadFile"
          >{{this.selected_file_name}}</label>
          <br />
          <button
          :disabled="checkUserPermission(true,permissionMode.ADD) == false"
            data-cy="upload_btn"
            type="button"
            style="min-width:100px;width: 10%;"
            class="btn btn-primary"
            @click="uploadFile({})"
          >アップロード</button>
          <button
            type="button"
            style="min-width:100px;width: 10%;background: #A6A6A6;border-color:#A6A6A6;"
            class="btn btn-primary"
            @click="cancelUpload"
            v-if="showCancelUpload"
          >キャンセル</button>
        </div>

        <div
          v-if="error_msg.length > 0"
          style="margin: 30px;"
          class="alert alert-danger"
          v-html="error_msg"
        ></div>
      </div>
      <br />
      <ag-grid-vue v-if="false" style="width: 100%; height: 530px" class="ag-blue" :gridOptions="gridOptions"></ag-grid-vue>
      <sub-table-cer v-if="showSubTableCer"/>
      <sub-table-dev v-if="showSubTableDev"/>

      <sub-table-associated-device v-if="showSubTableAssociatedDevice"/>
      <sub-table-device-embedded-detail v-if="showSubTableDeviceEmbeddedDetail"/>
      <br />

      <button v-if="showSubTableCer || showSubTableDev || showSubTableAssociatedDevice || showSubTableDeviceEmbeddedDetail"
       class="btn btn-primary" style="min-width:100px;width:100px;float: right;margin-left: 10px;" @click="onExecuteClear">クリア</button>

      <button v-if="showSubTableCer || showSubTableDev || showSubTableAssociatedDevice || showSubTableDeviceEmbeddedDetail"
       class="btn btn-primary" style="min-width:100px;width:100px;float: right;margin-left: 10px;background: #92D050;border-color:#92D050;"  @click="onConfirmExecuteProcessAndApply" >申請</button>

      <button v-if="showSubTableCer || showSubTableDev || showSubTableAssociatedDevice || showSubTableDeviceEmbeddedDetail"
       class="btn btn-primary" style="min-width:100px;width:100px;float: right;margin-left: 10px;background: #92D050;border-color:#92D050;"  @click="onConfirmExecuteProcessOnlySave" >下書保存</button>

    </div>
    <br>
    <confirmation-modal tag="applicationConfirmatioProcessOnlyModal" />
    <confirmation-modal tag="onConfirmExecuteProcessOnlySave" @done="onConfirmExecuteProcessOnly" />
    <application-confirmation-modal tag="certificateApplicationConfimationModal" />
  </div>
  
</template>

<script>
import Vue from "vue";
// import { AgGridVue } from "ag-grid-vue";
import { fields, filed_types } from "@/rules/fields_bulk_import";
import { utils } from "@/libs/utils";

import _debug from "debug";
var mdebug = _debug("esma:bulk_import");
// import fieldBoxes from "@/components/form-field";
import acl from "@/rules/acl_rules";
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
import applicationConfirmationModal from '@/components/modals/application-confirmation-modal';

import subTableCer from '@/components/sub_pages/sub-table-temp-certificate-information';
import subTableDev from '@/components/sub_pages/sub-table-temp-device-embedded-information';

import subTableDeviceEmbeddedDetail from '@/components/sub_pages/sub-table-temp-device-embedded-detail';
import subTableAssociatedDevice from '@/components/sub_pages/sub-table-temp-associated_device';

import constants from "@/rules/constants";

import axios from "axios";
import { bus } from "@/libs/bus";

export default {
  mixins: [mixinPageCommon, mixinDatasource],
  components: {
    'sub-table-cer': subTableCer,
    'sub-table-dev': subTableDev,
    'sub-table-associated-device': subTableAssociatedDevice,
    'sub-table-device-embedded-detail': subTableDeviceEmbeddedDetail,
    'application-confirmation-modal':applicationConfirmationModal
    // "field-box": fieldBoxes,
    // "ag-grid-vue": AgGridVue
  },
  data() {
    return {
      btn_cer_label:"（旧データ用）証書情報テンプレート",
      btn_dev_label:"（旧データ用）機器情報テンプレート",
      btn_associated_device_label:"ソフトウェア情報テンプレート",
      btn_device_embedded_detail_label:"組込情報テンプレート",
      dropdown_label:"テンプレートをダウンロード（Excel）",
      api_name: "bulk_import",
      page_acl: acl.maintenance,
      file_selected_event: false,
      selected_file_name: null,
      process_stage: "idle",
      uploading: false,
      error_msg: "",
      show_sub_table_cer:false,
      show_sub_table_dev:false,

      show_sub_table_associated_device:false,
      show_sub_table_device_embedded_detail:false,

      tab_name_mode:false
    };
  },
  computed: {
    showSubTableAssociatedDevice:{
      get(){
        return this.show_sub_table_associated_device;
      },
      set(v){
        this.show_sub_table_associated_device = v;
      }
    },
    showSubTableDeviceEmbeddedDetail:{
      get(){
        return this.show_sub_table_device_embedded_detail;
      },
      set(v){
        this.show_sub_table_device_embedded_detail = v;
      }
    },
    showSubTableDev:{
      get(){
        return this.show_sub_table_dev;
      },
      set(v){
        this.show_sub_table_dev = v;
      }
    },
    showSubTableCer:{
      get(){
        return this.show_sub_table_cer;
      },
      set(v){
        this.show_sub_table_cer = v;
      }
    },
    processStage: {
      get() {
        return this.process_stage;
      },
      set(v) {
        this.process_stage = v;
      }
    },
    showChoseFile() {
      return this.processStage == "idle";
    },
    showUploadFile() {
      return this.processStage == "file_selected";
    },
    showCancelUpload() {
      return this.processStage == "file_selected";
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields() {
      return this.tabFieldList;
    },
    tabFieldList() {
      return [
        utils.extend(fields.device_control_number, {}),
        utils.extend(fields.computer_name, {}),
        utils.extend(fields.equipment_in_charge_department, {}),
        utils.extend(fields.equipment_in_charge_team, {}),
        utils.extend(fields.equipment_in_charge_system, {}),
        utils.extend(fields.virtual_environment, {}),
        utils.extend(fields.virtual_base_unit, {}),
        utils.extend(fields.leasing_or_rental, {}),
        utils.extend(fields.manufacture_name, {})
      ];
    }
  },
  methods: {
    // bulkImportConfimationModalDone(mode){
    //   console.log("bulkImportConfimationModalDone(mode)",mode)
    //   if(mode == "no"){
    //   }else if(mode == "yes"){
    //     this.onExecuteProcess();
    //   }
    // },
    onConfirmExecuteProcessOnly(mode){
      if(mode == "yes"){
        if(this.tab_name_mode == false){
          return;
        }
        var syubetu = "";
        if(this.tab_name_mode == "temp_device_embedded_information"){
          syubetu = constants.SYUBETU.DEVICE;
        }else if(this.tab_name_mode == "temp_certificate_information"){
          syubetu = constants.SYUBETU.CERTIFICATE;
        }else if(this.tab_name_mode == "temp_associated_device"){
          syubetu = constants.SYUBETU.ASSOCIATED_DEVICE;
        }else if(this.tab_name_mode == "temp_device_embedded_detail"){
          syubetu = constants.SYUBETU.DEVICE_DETAIL;
        }
        var url = '/' + this.tab_name_mode + '/process_only/';
        this.$store.state[this.stateCurrentEditing]["approval_status"] = "下書中";
        this.$ajax.post(url, {syubetu:syubetu}, (err, result) => {
          if(err){
            this.$notify({
              title: 'データの処理に失敗しました。',
              text: err,
              type: 'error',
              duration: 10000
            });
          }else{
            bus.$emit("applicationConfirmatioProcessOnlyModal",{
              title: "",
              message: syubetu + "を下書保存しました。",
              yes_label: "",
              no_label: "OK",
              yes_color:"",
              no_color:"default",
              model_height:"50"
            })
          }
        })
      }
    },
    onConfirmExecuteProcessOnlySave(){
      this.validateMaker((validated)=>{
        if(validated != true){
          return;
        }
        console.log("onConfirmExecuteProcessOnlySave")
        bus.$emit("onConfirmExecuteProcessOnlySave",{
          message: "よろしいですか？",
          title: "登録情報を下書保存します。",
          yes_label: "下書保存",
          no_label: "戻る",
          yes_color:"primary",
          no_color:"",
          model_height:"50"
        });
      })
    },
    //onAfterProcess(){
    //var go_to_url = (this.tab_name_mode == "temp_device_embedded_information")?"page_0010_device_embedded_information":"page_0040_certificate_information";
      //setTimeout(() => {
        //this.$router.push({
          //name: go_to_url
        //});
      //}, 500);
    //},
    onConfirmExecuteProcessAndApply(){

      this.validateMaker((validated)=>{
        if(validated != true){
          return;
        }
        if(this.tab_name_mode == false){
          return;
        }
        var syubetu = "";
        var on_finish_url_name = ""
        if(this.tab_name_mode == "temp_device_embedded_information"){
          syubetu = constants.SYUBETU.DEVICE;
           on_finish_url_name = "page_0010_device_embedded_information"
        }else if(this.tab_name_mode == "temp_device_embedded_detail"){
          on_finish_url_name = "page_0010_device_embedded_information"
          syubetu = constants.SYUBETU.DEVICE_DETAIL;
        }else if(this.tab_name_mode == "temp_certificate_information"){
          syubetu = constants.SYUBETU.CERTIFICATE;
          on_finish_url_name = "page_0040_certificate_information"
        }else if(this.tab_name_mode == "temp_associated_device"){
          syubetu = constants.SYUBETU.ASSOCIATED_DEVICE;
          on_finish_url_name = "page_0040_certificate_information"
        }
        bus.$emit("certificateApplicationConfimationModal",{
          application_mode:"bulk_import",
          title_prefix:syubetu,
          syubetu:syubetu,
          title_suffix:"（一括取込・"+syubetu+"）",
          process_import_url:'/' + this.tab_name_mode + '/process_and_apply/',
          on_finish_url_name:on_finish_url_name,
          ref_id:this.certificateManagementNumber,
        });
      })
    },
    validateMaker(cb){
      if(this.tab_name_mode == "temp_certificate_information"){
        this.$notify({clear:true});

        this.$ajax.post('/temp_certificate_information/validate_maker/' , {}, (err, result) => {
          console.log({err,result},result.valid)
          if(result.valid == true){
              this.$notify({
                title: 'Success',
                text: "Maker validated.",
                type: 'success',
                duration: 2000
              });
              cb(true)
          }else{
              this.$notify({
                title: 'Can not process',
                text: "The maker value of " + result.invalid_count + " rows are invalid, please fix it and repead",
                type: 'error',
                duration: 12000
              });
              cb(false)
          }
        })
      }else{
        cb(true);
      }

    },
     onExecuteClear(){
      if(this.tab_name_mode == false){
        return;
      }
      this.showSubTableDev = false;
      this.showSubTableCer = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = false;

      this.$ajax.post('/' + this.tab_name_mode + '/clear/' , {}, (err, result) => {
        if(err){
          this.$notify({
            title: 'データのクリアに失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        }
        if(this.tab_name_mode == "temp_device_embedded_information"){
          this.selectDeviceEmbeddedInformation()
        }else if(this.tab_name_mode == "temp_certificate_information"){
          this.selectCertificate()
        }else if(this.tab_name_mode == "temp_associated_device"){
          this.selectAssociatedDevice()
        }else if(this.tab_name_mode == "temp_device_embedded_detail"){
          this.selectDeviceEmbeddedDetail()
        }
        //TODO: should emit a refresh.
      })
    },
    selectDeviceEmbeddedInformation(){
      this.dropdown_label = this.btn_dev_label;
      this.tab_name_mode = "temp_device_embedded_information";
      this.showSubTableCer = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = false;
      this.showSubTableDev = true;
    },
    selectCertificate(){
      this.dropdown_label = this.btn_cer_label;
      this.tab_name_mode = "temp_certificate_information";
      this.showSubTableDev = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = false;
      this.showSubTableCer = true;
    },
    selectAssociatedDevice(){
      this.dropdown_label = this.btn_associated_device_label; 
      this.tab_name_mode = "temp_associated_device";
      this.showSubTableDev = false;
      this.showSubTableAssociatedDevice = true;
      this.showSubTableDeviceEmbeddedDetail = false;
      this.showSubTableCer = false;
    },
    selectDeviceEmbeddedDetail(){
      this.dropdown_label = this.btn_device_embedded_detail_label; 
      this.tab_name_mode = "temp_device_embedded_detail";
      this.showSubTableDev = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = true;
      this.showSubTableCer = false;
    },
    cancelUpload() {
      this.selected_file_name = null;
      this.file_selected_event = null;
      this.processStage = "idle";
    },
    uploadFile(options) {
      this.error_msg = "";
      this.processStage = "uploading";
      this.uploading = true;
      this.result_array = [];
      this.result_executed = false;
      var files = this.file_selected_event.target.files;
      if (!files[0]) {
        return;
      }
      var csv_data = new FormData();
      csv_data.append("csv", files[0]);
      mdebug("csv_data", csv_data);
      this.showSubTableDev = false;
      this.showSubTableCer = false;
      this.showSubTableAssociatedDevice = false;
      this.showSubTableDeviceEmbeddedDetail = false;
      axios
        .post(this.$ajax.serverUrl + "/csv/upload/" + this.api_name, csv_data, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          var data = response.data;
          mdebug("Upload done", response);
          if (response.data.success == true) {
            this.uploading = false;
            if(data.data.table == "temp_certificate_information"){
              this.selectCertificate()
            }else if(data.data.table == "temp_device_embedded_information"){
              this.selectDeviceEmbeddedInformation()
            }else if(data.data.table  == "temp_associated_device"){
              this.selectAssociatedDevice()
            }else if(data.data.table  == "temp_device_embedded_detail"){
              this.selectDeviceEmbeddedDetail()
            }else{
            }
            return this.processStage = "idle";
          } else {
            this.uploading = false;
            try {
              this.error_msg = "エラー ：" + JSON.stringify(response.data.error).replace(/"/g, "") + "";
            } catch (error) {
              this.error_msg = "エラー ：" + response.data.error + "";
            }

            this.processStage = "preview_error";
            this.file_selected_event = null;
            this.selected_file_name = null;
            this.uploading = false;
            this.count_error++;
            this.result_executed = true;
          }
        })
        .catch(error => {
          this.error_msg = "エラー ：：： (" + error + ")";

          this.result_executed = true;
          mdebug("upload File error:", error);
          this.count_error++;
          this.processStage = "preview_error";
          this.result_error = "failed to upload: " + error;
          this.file_selected_event = null;
          this.selected_file_name = null;
          this.uploading = false;
        });
    },
    choseFile() {
      var csv_file = this.$refs.csv_file;
      csv_file.click();
    },
    fileClicked(e) {
      var csv_file = this.$refs.csv_file;
      csv_file.value = null;
    },
    fileSelected(e) {
      var files = e.target.files;
      if (!files[0]) {
        return;
      }
      mdebug("file_selected", files[0]);
      this.processStage = "file_selected";
      this.file_selected_event = e;
      this.selected_file_name = files[0].name;
    },
    createColumnDefs() {
      var arr = this.defaultCreateColumn;
      var i = 0;
      this.tabFieldList.forEach(f => {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };
        arr.push(fi);
      });

      [fields.more_details, fields.button_options].forEach(f => {
        var fi = {
          headerName: f.tab_label,
          sortable: false,
          field: f.id,
          width: 50,
          maxWidth: 50,
          pinned: 'right',
          cellRenderer: params => {
            if (params.column.colId == "more_details") {
              return this.createGridTextButton(
                "詳細",
                "color: #5b9bd5;",
                this.onDetailsClick,
                params.data
              );
            }
            if (params.column.colId == "button_options") {
              return this.createGridButton(
                "glyphicon glyphicon glyphicon-unchecked",
                "color: #5b9bd5;",
                this.onSelectedClickDatasource,
                params.data
              );
            }
          }
        };
        arr.push(fi);
      });
      return arr;
    }
  },
  mounted() {
    
  },
  beforeDestroy() {},
  beforeMount() {

  }
};
</script>
<style >

.dropdown_yellow_import{
    margin-left: 0!important;
    padding: 8px 10px!important;
    width: 300px!important;
    font-size: 14px!important;
}
.box2 {
    padding: 0.5em 1em;
    border: solid 1px #6091d3;
    border-radius: 10px;
    width: 90%;
    margin: 0 auto;
}
.box2 p {
    margin: 0; 
    padding: 0;
}
</style>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0093_old_bulk_import.vue?4ae6540e